export default __webpack_public_path__ + "static/media/la-regular-400.8dc1cedf.woff2";